var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.content))]),_c('div',{attrs:{"id":"sosMap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }